/** Catálogo alemán — claves planas; misma estructura que en.ts */
const de = {
  unique_death_history: "Todesverlauf",
  reg_events: "Events",
  reg_details: "Details & Belohnungen",
  reg_details_pending: "Details werden bald bekannt gegeben.",
  reg_open: "Offen",
  reg_closed: "Geschlossen",
  reg_joined: "Angemeldet",
  reg_equalized: "Angeglichen",
  reg_standard: "Standard",
  reg_cancel_registration: "Anmeldung stornieren",
  reg_joined_hint: "Du bist für dieses Event angemeldet.",
  reg_open_hint: "Die Anmeldung ist offen. Melde dich an, um teilzunehmen.",
  reg_closed_hint: "Die Anmeldung ist geschlossen.",
  reg_translating: "Wird übersetzt…",
  reg_translation_error: "Übersetzung nicht verfügbar. Der Originaltext wird angezeigt.",
  reg_retry: "Erneut versuchen",

  battle_pass: 'Battle Pass',
  menu_main: 'Hauptmenü',
  menu_tools: 'Werkzeuge',
  menu_open: 'Menü öffnen',
  menu_close: 'Menü schließen',
  menu_home: 'Zurück zum Start',
  guide: 'Anleitung',
  daily_login: 'Täglicher Login',
  spin_title: 'Rad',
  special_offer: 'Sonderangebot',
  auction_system: 'Auktionshaus',
  title_manager: 'Anpassung',
  ranking: 'Rangliste',
  unique: 'Uniques',
  job_system: 'Job-System',
  vip_system: 'VIP',
  donation: 'Spende',
  surveys: 'Umfragen',
  settings: 'Einstellungen',
  messages: 'Nachrichten',
  unique_status_title: 'Aktueller Status',
  unique_logs_title: 'Verlaufsprotokoll',
  unique_table_name: 'Unique',
  unique_table_character: 'Charakter',
  unique_table_status: 'Status',
  unique_table_event: 'Ereignis',
  unique_table_map: 'Karte',
  unique_table_time: 'Zeit',
  unique_status_alive: 'Am Leben',
  unique_status_dead: 'Tot',
  unique_event_spawn: 'Erscheinen',
  unique_event_death: 'Getötet',
  unique_refresh: 'Aktualisieren',
  unique_sort_alive_first: 'Sortierung: Lebende zuerst',
  unique_sort_dead_first: 'Sortierung: Tote zuerst',
  unique_deaths_tooltip_title: 'Letzte 5 Tötungen',
  unique_deaths_empty: 'Keine Tötungen aufgezeichnet',
  unique_load_error: 'Unique-Verlauf konnte nicht geladen werden.',
  unique_no_data: 'Keine Daten gefunden.',
  unique_logs_empty: 'Noch keine Verlaufsereignisse.',
  schedule: 'Zeitplan',
  sched_no_events: 'Keine Ereignisse geplant.',
  sched_running: 'LÄUFT',
  sched_load_error: 'Zeitplan konnte nicht geladen werden. Bitte später erneut versuchen.',
  reg_register: 'Registrieren',
  reg_remove_register: 'Registrierung entfernen',
  reg_processing: 'Wird verarbeitet...',
  reg_registered_success: 'Sie haben sich erfolgreich für das Ereignis registriert',
  reg_unregistered_success: 'Sie haben sich erfolgreich vom Ereignis abgemeldet',
  reg_no_events: 'Keine Ereignisse verfügbar.',
  reg_load_error: 'Ereignisse konnten nicht geladen werden. Bitte später erneut versuchen.',
  reg_error_invalid_event: 'Ungültiges Ereignis',
  reg_error_not_logged_in: 'Sie müssen angemeldet sein, um sich für Ereignisse zu registrieren',
  reg_error_not_available: 'Das Ereignis ist nicht für die Registrierung verfügbar',
  reg_error_already_registered: 'Fehler bei der Registrierung. Sie sind möglicherweise bereits registriert.',
  reg_error_unregister: 'Fehler beim Abmelden vom Ereignis',
  reg_error_processing: 'Fehler beim Verarbeiten der Anfrage',
  reg_error_connection: 'Verbindungsfehler. Bitte erneut versuchen.',
  reg_modal_title: 'Equalized System',
  reg_weapons: 'Waffen (Wählen Sie 1)',
  reg_buffs: 'Buffs (Wählen Sie 1)',
  reg_essence: 'Essence (Immer aktiv)',
  reg_force: 'Force (Immer aktiv)',
  reg_btn_register: 'Registrieren',
  reg_btn_cancel: 'Abbrechen',
  register: 'Registrieren',
  r_ia: 'R-AI',
  chat_welcome_message: 'Hallo! 👋 Ich bin <strong>R-AI</strong>, dein KI-Assistent für Silkroad Origins.',
  chat_welcome_question: 'Wie kann ich dir heute helfen?',
  chat_input_placeholder: 'Nachricht eingeben...',
  chat_send_button: 'Senden',
  chat_send_title: 'Nachricht senden',
  chat_char_count: '{current} / {max}',
  chat_load_error: 'Chatverlauf konnte nicht geladen werden. Bitte später erneut versuchen.',
  chat_error_connection: 'Verbindungsfehler. Bitte erneut versuchen.',
  drop_log: 'Drop-Log',
  log_table_item: 'Item',
  log_table_character: 'Charakter',
  log_table_monster: 'Monster',
  log_table_map: 'Karte',
  log_table_date: 'Datum',
  log_table_ago: 'Vor',
  log_search_placeholder: 'Suchen...',
  log_time_seconds: 'Sek',
  log_time_minutes: 'Min',
  log_time_hours: 'Std',
  log_time_days: 'T',
  log_filter_race: 'Rasse',
  log_filter_race_chinese: 'Chinese',
  log_filter_race_euro: 'Euro',
  log_filter_type: 'Typ',
  log_filter_time_all: 'Alle',
  log_filter_time_today: 'Heute',
  log_filter_time_week: 'Diese Woche',
  log_filter_time_month: 'Diesen Monat',
  log_filter_apply: 'Anwenden',
  log_filter_reset: 'Zurücksetzen',
  log_load_error: 'Drop-Log konnte nicht geladen werden. Bitte später erneut versuchen.',
  log_no_results: 'Keine Drops entsprechen Ihren Filtern.',
  log_modal_i_need_it: 'Ich brauche es',
  log_modal_sending: 'Wird gesendet...',
  log_modal_sent: 'Gesendet',
  log_modal_error: 'Fehler',
  log_modal_connection_error: 'Verbindungsfehler',
  log_modal_message_template: 'Hallo, ich interessiere mich für das {item}, das du gedroppt hast. Was verlangst du dafür?',
  log_chat_button_title: 'Per Chat kontaktieren',
  log_chat_self_error: 'Nachrichten können nicht an sich selbst gesendet werden',
  languages: 'Sprachen',
  server_time: 'Serverzeit',
  loading_data: 'Daten werden geladen...',
  auth_loading: 'Authentifizierung läuft...',
  auth_error: 'Authentifizierung fehlgeschlagen. Bitte aus dem Spiel neu öffnen.',
  bp_duration: 'Dauer: {start} - {end} ({remaining} verbleibend)',
  bp_level: 'Level',
  bp_buy_pass: 'Pass kaufen',
  bp_premium_active: 'Premium-Pass aktiv',
  bp_premium_reward: 'Premium-Belohnung',
  bp_max_level: 'Maximales Level: {level}',
  bp_no_active: 'Kein aktiver Battle Pass',
  bp_reward_success: 'Belohnung erfolgreich eingelöst!',
  bp_claim_error: 'Belohnung konnte nicht eingelöst werden. Bitte später erneut versuchen.',
  bp_exp_info_title: 'Battle Pass Erfahrung',
  bp_exp_tower_defense_victory: 'Tower Defense: Sieg: 45 Punkte | Niederlage: 5 Punkte',
  bp_exp_hell_prison_victory: 'Höllen-Gefängnis: Sieg: 50 Punkte | Niederlage: 10 Punkte',
  bp_exp_witch_hunt_victory: 'Hexenjagd: Sieg: 50 Punkte | Niederlage: 10 Punkte',
  bp_exp_survival: 'Überleben: 1. Platz: 30 Punkte | 2. Platz: 15 Punkte | 3. Platz: 5 Punkte',
  bp_exp_last_man_standing: 'Letzter Mann: Sieg: 95 Punkte',
  bp_exp_madness: 'Wahnsinn: 1. Platz: 30 Punkte | 2. Platz: 15 Punkte | 3. Platz: 5 Punkte',
  bp_exp_garden_job_victory: 'Garten (Job): Sieg: 50 Punkte | Niederlage: 10 Punkte',
  bp_exp_capture_flag_victory: 'Flagge erobern: Sieg: 50 Punkte | Niederlage: 10 Punkte',
  bp_exp_battle_arena_victory: 'Kampf-Arena: Sieg: 50 Punkte | Niederlage: 10 Punkte',
  bp_exp_league_map_victory: 'Liga-Karte: Sieg: 55 Punkte | Niederlage: 10 Punkte',
  bp_exp_medusa_victory: 'Medusa: Sieg: 100 Punkte | Niederlage: 20 Punkte',
  bp_exp_roc_victory: 'Roc: Sieg: 100 Punkte | Niederlage: 20 Punkte',
  bp_exp_normal_uniques_victory: 'Normale Uniques: Sieg: 5 Punkte | Niederlage: 3 Punkte',
  bp_exp_arabian_uniques_victory: 'Arabische Uniques: Sieg: 7 Punkte | Niederlage: 5 Punkte',
  bp_exp_legendary_uniques_victory: 'Legendäre Uniques: Sieg: 10 Punkte | Niederlage: 7 Punkte',
  bp_exp_job_kills: 'Job-Tötungen: 2 Punkte pro Tötung',
  bp_exp_job_delivery: 'Job-Lieferung: 15 Punkte pro Lieferung',
  bp_exp_global_chat: 'Globaler Chat: 2 Punkte pro Chat-Nutzung',
  bp_exp_summary:
    'BP-EP aus Ereignissen sammeln: Tower Defense, Höllen-Gefängnis, Hexenjagd, Überleben, Wahnsinn, Garten-Job, Flagge erobern, Kampf-Arena, Liga-Karte, Medusa, Roc, Uniques, Job-Tötungen/-Lieferungen und globaler Chat.',
  silk_confirm_cost: 'Kosten: {amount} Silks',
  silk_confirm_balance: 'Ihr Guthaben: {amount} Silks',
  silk_confirm_after: 'Guthaben nach Kauf: {amount} Silks',
  silk_confirm_not_enough: 'Sie haben nicht genug Silks für diesen Kauf.',
  silk_confirm_cancel: 'Abbrechen',
  silk_confirm_confirm: 'Bestätigen',
  bp_premium_confirm_title: 'Premium-Pass kaufen',
  bp_premium_confirm_msg: 'Alle Premium-Belohnungen dieser Saison freischalten.',
  bp_levelup_confirm_title: 'Level aufsteigen',
  bp_levelup_confirm_msg: 'Sofort ein Battle Pass Level gewinnen.',
  silk_confirm_price_label: 'Preis',
  silk_confirm_your_silk: 'Ihre Silks',
  silk_confirm_checking: 'Wird geprüft...',
  silk_confirm_unavailable: 'Nicht verfügbar',
  silk_confirm_retry_later: 'Später erneut versuchen',
  silk_confirm_not_enough_short: 'Nicht genug Silk',
  silk_confirm_processing: 'Wird verarbeitet',
  silk_confirm_processing_msg: 'Ihr Kauf wird verarbeitet...',
  silk_confirm_success: 'Erfolg',
  silk_confirm_failed: 'Fehlgeschlagen',
  silk_confirm_wait: 'Bitte warten',
  silk_confirm_close: 'Schließen',
  cal_schedule_label: 'Check-In-Zeitplan: {start} - {end}',
  cal_remaining_label: '({remaining} verbleibend)',
  cal_checked_in_status: '{checked} von {total} Tagen eingecheckt ({missed} Tag(e) verpasst)',
  cal_day_label: 'Tag {day}',
  cal_checkin_available: 'Sie können sich jetzt einchecken!',
  cal_next_checkin: 'Nächster Check-In in: {hours}Std {minutes}Min',
  cal_claim_error: 'Aktion konnte nicht abgeschlossen werden. Bitte später erneut versuchen.',
  cal_no_campaign: 'Keine aktive Kampagne',
  spin_daily_spins: '{max} tägliche Drehungen ({used}/{max})',
  spin_recent_rewards: 'Letzte 5 Belohnungen',
  spin_congratulations: 'Herzlichen Glückwunsch!',
  spin_probability: 'Wahrscheinlichkeit:',
  spin_daily_reached_tooltip: 'Tageslimit erreicht. Für weitere Nutzung mit Silk kaufen.',
  spin_reset_confirm_title: 'Zurücksetzen bestätigen',
  spin_reset_confirm_message: 'Möchten Sie die Drehungen wirklich zurücksetzen?',
  spin_reset_confirm_silk: '{amount} Silks',
  spin_reset_confirm_cancel: 'Abbrechen',
  spin_reset_confirm_confirm: 'Bestätigen',
  spin_reset_success: 'Drehungen erfolgreich zurückgesetzt!',
  spin_reset_error: 'Drehungen konnten nicht zurückgesetzt werden.',
  spin_error_spin: 'Das Rad konnte nicht gedreht werden.',
  spin_error_winner: 'Gewinner-Item nicht gefunden.',
  spin_error_connection: 'Verbindungsfehler mit dem Server.',
  so_title: 'Sonderangebot',
  so_recommended: 'Empfohlen',
  so_offer_ends_in: 'Angebot endet in',
  so_buy: 'KAUFEN',
  so_available: 'Verfügbar',
  so_sold_out: 'Ausverkauft',
  so_processing: 'Wird verarbeitet...',
  so_purchase_success: 'Kauf erfolgreich!',
  so_purchase_error: 'Kauffehler',
  so_network_error: 'Netzwerkfehler',
  so_confirm_title: 'Kauf bestätigen',
  so_confirm_message: '{name} kaufen?',
  so_no_offers: 'Keine aktiven Angebote',
  auc_time_left: 'Verbleibende Zeit',
  auc_bid_concluded: 'Gebot abgeschlossen',
  auc_winner: 'Gewinner',
  auc_auction_starting_soon: 'Auktion beginnt bald',
  auc_enter_bid: 'Geben Sie Ihr Gebot ein',
  auc_bid_now: 'Jetzt bieten',
  auc_be_first_to_bid: 'Seien Sie der Erste, der bietet',
  auc_current_bid: 'Aktuelles Gebot',
  auc_by: 'von',
  auc_latest_bids: 'Letzte Gebote',
  auc_auction_ended: 'Die Auktion ist beendet. Herzlichen Glückwunsch an den Gewinner!',
  auc_wait_next_auction: 'Bitte warten Sie, bis die nächste Auktion beginnt.',
  auc_item_rewards: 'Item-Belohnungen',
  auc_no_rewards: 'Keine Belohnungen verfügbar',
  auc_bid_success: 'Gebot erfolgreich platziert!',
  auc_bid_error: 'Fehler beim Platzieren des Gebots.',
  auc_invalid_bid: 'Geben Sie einen gültigen Gebotsbetrag ein.',
  tm_tab_name: "Name",
  tm_name_colors: "Gespeicherte Namensfarben",
  tm_name_apply: "Farbe anwenden",
  tm_name_select: "Farbe auswählen",
  tm_name_empty: "Noch keine gespeicherten Farben.",
  tm_name_reuse: "Jede Farbe kostet 999 Silks. Gekaufte Farben sind kostenlos wiederverwendbar. Warte 30 Sekunden zwischen Änderungen.",
  tm_name_buy: "Namensfarbe kaufen",
  tm_name_purchased: "Namensfarbe gekauft.",
  tm_name_applied: "Namensfarbe angewendet.",
  tm_name_owned: "Bereits gekauft",
  tm_name_error: "Farbe konnte nicht verarbeitet werden.",
  tm_cooldown: "Warte {seconds} Sekunden vor einer weiteren Änderung.",
  tm_tab_title: 'Titel',
  tm_tab_icon: 'Symbol',
  tm_tab_tag: 'Tag',
  tm_title_column: 'Titel',
  tm_tag_column: 'Tag',
  tm_actions_column: 'Aktionen',
  tm_enter_title: 'Titeltext eingeben...',
  tm_enter_tag: 'Tag-Text eingeben...',
  tm_test: 'Testen',
  tm_edit: 'Bearbeiten',
  tm_edit_title_modal_title: 'Titel bearbeiten',
  tm_price_edit: 'Bearbeitungspreis',
  tm_error_editing_title: 'Fehler beim Bearbeiten des Titels.',
  tm_title_edited: 'Titel erfolgreich aktualisiert.',
  tm_buy: 'Kaufen',
  tm_total_pay: 'Gesamtbetrag',
  tm_color_optional: 'Eigene Farbe (optional)',
  tm_edit_separate: 'Vorhandenen Titel bearbeiten (separat)',
  tm_price_title: 'Titel-Preis',
  tm_price_color: 'Farbpreis',
  tm_price_tag: 'Tag-Preis',
  tm_price_icon_label: '{amount} Silks',
  tm_apply_title: 'Titel anwenden',
  tm_remove_title: 'Titel entfernen',
  tm_apply_tag: 'Tag anwenden',
  tm_remove_tag: 'Tag entfernen',
  tm_no_titles: 'Keine gespeicherten Titel.',
  tm_no_tags: 'Keine gespeicherten Tags.',
  tm_no_icons: 'Keine Symbole gefunden.',
  tm_icon_search: 'Symbole suchen...',
  tm_icon_left: 'Symbol Links',
  tm_icon_right: 'Symbol Rechts',
  tm_buy_title_modal_title: 'Titelkauf bestätigen',
  tm_buy_tag_modal_title: 'Tag-Kauf bestätigen',
  tm_buy_icon_modal_title: 'Symbolkauf bestätigen',
  tm_buy_title_label: 'Titel:',
  tm_buy_tag_label: 'Tag:',
  tm_buy_icon_label: 'Symbol:',
  tm_buy_price_label: 'Preis:',
  tm_buy_balance_label: 'Ihr Guthaben:',
  tm_buy_includes: 'Enthält:',
  tm_buy_includes_title_color: 'Titel + Benutzerdefinierte Farbe',
  tm_buy_not_enough: '⚠ Sie haben nicht genug Silks.',
  tm_buy_needs_more: 'Sie benötigen {amount} weitere Silks.',
  tm_buy_confirm: 'Kauf bestätigen',
  tm_buy_cancel: 'Abbrechen',
  tm_error_testing_title: 'Fehler beim Testen des Titels.',
  tm_error_buying_title: 'Fehler beim Kaufen des Titels.',
  tm_error_buying_tag: 'Fehler beim Kaufen des Tags.',
  tm_error_buying_icon: 'Fehler beim Kaufen des Symbols.',
  tm_error_applying_icon: 'Fehler beim Anwenden des Symbols.',
  tm_error_getting_balance: 'Fehler beim Abrufen des Silk-Guthabens.',
  tm_error_applying_title: 'Fehler beim Anwenden des Titels.',
  tm_error_applying_tag: 'Fehler beim Anwenden des Tags.',
  tm_error_removing_title: 'Fehler beim Entfernen des Titels.',
  tm_error_removing_tag: 'Fehler beim Entfernen des Tags.',
  tm_processing: 'Wird verarbeitet...',
  tm_already_have_title: 'Sie besitzen diesen Titel bereits.',
  tm_already_have_tag: 'Sie besitzen dieses Tag bereits.',
  tm_already_have_icon: 'Sie besitzen dieses Symbol bereits.',
  tm_not_enough_silk: 'Nicht genug Silk.',
  tm_title_applied: 'Titel erfolgreich angewendet.',
  tm_title_purchased: 'Titel gekauft! Viel Spaß mit Ihrem neuen Titel.',
  tm_tag_applied: 'Tag erfolgreich angewendet.',
  tm_icon_applied: 'Symbol erfolgreich angewendet.',
  tm_title_removed: 'Titel erfolgreich deaktiviert.',
  tm_tag_removed: 'Tag erfolgreich entfernt.',
  tm_icon_purchased: 'Symbol erfolgreich gekauft.',
  tm_test_applied: 'Titel-Vorschau angewendet (temporär).',
  ranking_search_placeholder: 'Spieler suchen...',
  ranking_filter_race: 'Rasse',
  ranking_race_chinese: 'Chinese',
  ranking_race_euro: 'Euro',
  ranking_filter_mastery: 'Meisterschaft',
  ranking_mastery_bicheon: 'Bicheon',
  ranking_mastery_pacheon: 'Pacheon',
  ranking_mastery_heuksal: 'Heuksal',
  ranking_mastery_warrior: 'Krieger',
  ranking_mastery_rogue: 'Schurke',
  ranking_mastery_wizard: 'Zauberer',
  ranking_filter_reset: 'Zurücksetzen',
  ranking_filter_refresh: 'Rangliste aktualisieren',
  ranking_col_character: 'Charakter',
  ranking_col_guild: 'Gildenname',
  ranking_col_points: 'Punkte',
  ranking_no_results: 'Keine Spieler entsprechen Ihren Filtern.',
  ranking_empty: 'Ranglisten-Daten noch nicht verfügbar. Bitte später erneut versuchen.',
  ranking_error: 'Rangliste konnte nicht geladen werden. Tippen Sie ↺ zum Wiederholen.',
  ranking_error_auth: 'Rangliste konnte nicht geladen werden. Tippen Sie ↺ zum Wiederholen.',
  ranking_player_title: 'Spieler-Rangliste',
  ranking_guild_title: 'Gilden-Rangliste',
  ranking_mastery_title: 'Meisterschafts-Rangliste',
  ranking_arena_title: 'Arena-PVP-Rangliste',
  ranking_profile_loading: 'Charakterprofil wird geladen...',
  ranking_profile_error_title: 'Fehler',
  ranking_profile_error_message: 'Charakterprofil konnte nicht geladen werden.',
  ranking_profile_back: 'Zurück zur Rangliste',
  ranking_profile_inventory: 'Inventar',
  ranking_profile_avatar: 'Avatar',
  ranking_profile_level: 'Lv.',
  ranking_profile_strength: 'Stä:',
  ranking_profile_intelligence: 'Int:',
  ranking_profile_guild: 'Gilde:',
  ranking_profile_no_guild: '<keine>',
  job_level: 'Stufe',
  job_daily_progress: 'Täglicher Arbeitsfortschritt',
  job_claimed: 'Eingelöst',
  job_completed: 'Abgeschlossen',
  job_in_progress: 'In Bearbeitung',
  job_gold: 'Gold',
  job_min: 'Min',
  job_delivery_history: 'Heutige Lieferhistorie',
  job_route: 'Route',
  job_gold_earned: 'Verdientes Gold',
  job_delivery_time: 'Lieferzeit',
  job_delivery_hour: 'Lieferstunde',
  job_no_deliveries_today: 'Heute keine Lieferungen registriert.',
  job_no_job_info: 'Keine Job-Informationen für Ihren Charakter verfügbar.',
  job_login_required: 'Sie müssen sich anmelden, um Ihren Job-Fortschritt zu sehen.',
  job_hwid_error: 'Hardware-Informationen konnten nicht abgerufen werden.',
  job_level_error: 'Job-Stufe konnte nicht abgerufen werden.',
  job_no_configuration: 'Keine Konfiguration für diesen Job-Typ verfügbar.',
  job_merchant: 'Händler',
  job_thief: 'Dieb',
  job_hunter: 'Jäger',
  job_unknown: 'Unbekannt',
  job_invalid_data: 'Ungültige Daten',
  job_already_claimed_today: 'Sie haben die heutige Belohnung bereits eingelöst.',
  job_complete_progress_first: 'Sie müssen den täglichen Fortschritt abschließen, bevor Sie die Belohnung einlösen können.',
  job_no_reward_for_level: 'Keine Belohnung für Ihre aktuelle Stufe verfügbar.',
  job_reward_claimed_success: 'Belohnung erfolgreich eingelöst.',
  job_success: 'Erfolg',
  job_error: 'Fehler',
  job_network_error: 'Netzwerkfehler',
  job_protected_cargo: 'Geschützte Ware',
  job_stolen_cargo: 'Gestohlene Ware',
  cupon_title: 'Gutscheine',
  cupon_level_required: 'Stufe',
  cupon_rewards_title: 'Gutschein-Belohnungen',
  cupon_expires_in: 'Läuft ab in',
  cupon_claim_button: 'Gutschein einlösen',
  cupon_claimed_button: 'Eingelöst',
  cupon_confirm_button: 'Bestätigen',
  cupon_resend_button: 'Code erneut senden',
  cupon_verification_title: 'Bestätigungscode eingeben',
  cupon_choose_channel: 'Where should we send your code?',
  cupon_contact_missing: 'Not configured',
  cupon_whatsapp_verify: 'Verified number required',
  cupon_configure_contact: 'Configure WhatsApp in Settings',
  cupon_sent_via: 'Code sent via {channel}',
  cupon_code_sent_info: 'Ein Bestätigungscode wird an Ihre E-Mail gesendet',
  cupon_code_sent_button: 'Gesendet - E-Mail prüfen',
  cupon_coupon_claimed: 'Gutschein erfolgreich eingelöst! Prüfen Sie Ihre Truhe im Spiel.',
  cupon_no_coupons: 'Derzeit keine Gutscheine verfügbar',
  cupon_already_claimed: 'Sie haben diesen Gutschein bereits eingelöst',
  cupon_request_error: 'Fehler beim Anfordern des Codes. Erneut versuchen.',
  cupon_complete_code: 'Sie müssen den vollständigen 6-stelligen Code eingeben',
  cupon_processing_error: 'Fehler beim Verarbeiten der Anfrage. Erneut versuchen.',
  cupon_sending: 'Wird gesendet...',
  cupon_processing: 'Wird verarbeitet...',
  settings_tab_general: 'Allgemein',
  settings_tab_notifications: 'Benachrichtigungen',
  settings_tab_restrictions: 'Einschränkungen',
  settings_label_language: 'Sprache',
  settings_label_timezone: 'Zeitzone',
  settings_label_country: 'Land',
  settings_label_whatsapp: 'WhatsApp',
  settings_btn_verify: 'Überprüfen',
  settings_btn_confirm: 'Bestätigen',
  settings_btn_save: 'Speichern',
  settings_btn_validate_now: 'Jetzt validieren',
  settings_btn_validate_whatsapp: 'Per WhatsApp validieren',
  settings_btn_validate_authenticator: 'Per Authenticator validieren',
  settings_placeholder_code: 'Code',
  settings_placeholder_phone: '1234567890',
  settings_no_events: 'Keine Ereignisse konfiguriert',
  settings_minutes_before: 'Min. vorher',
  settings_time_remaining: 'Verbleibende Zeit bis zur nächsten erforderlichen Validierung',
  settings_validation_warning: 'Ihre Validierung läuft bald ab. Jetzt erneuern, um ohne Unterbrechungen weiterzuspielen.',
  settings_validation_active: 'Ihre Verbindung ist validiert und aktiv.',
  settings_validation_expired: 'Sie müssen Ihre Verbindung validieren, um sich im Spiel bewegen zu können.',
  settings_coming_soon: '(Demnächst)',
  settings_no_hwid: 'HWID konnte nicht abgerufen werden. Bitte im Spiel anmelden.',
  settings_code_sent: 'Code gesendet. Überprüfen Sie Ihr WhatsApp.',
  settings_whatsapp_verified_success: 'WhatsApp erfolgreich verifiziert',
  settings_error_update_config: 'Fehler beim Aktualisieren der Konfiguration',
  settings_error_phone_required: 'Bitte geben Sie eine Telefonnummer ein',
  settings_error_code_required: 'Bitte geben Sie einen gültigen 6-stelligen Code ein',
  settings_error_send_code: 'Fehler beim Senden des Bestätigungscodes',
  settings_error_verify_code: 'Fehler beim Überprüfen des Codes',
  settings_error_validate_connection: 'Fehler beim Validieren der Verbindung',
  settings_error_code_incorrect: 'Falscher Code',
  settings_no_results: 'Keine Ergebnisse gefunden',
  settings_searching: 'Suche...',
  messages_page_title: 'Chat',
  messages_conversations: 'Unterhaltungen',
  messages_new_chat: 'Neuer Chat',
  messages_search_player: 'Spieler suchen...',
  messages_type_message: 'Nachricht eingeben...',
  messages_send: 'Senden',
  messages_attach_item: 'Item anhängen',
  messages_online: 'Online',
  messages_offline: 'Offline',
  messages_no_messages: 'Noch keine Nachrichten',
  messages_no_conversations: 'Keine Unterhaltungen',
  messages_loading: 'Laden...',
  messages_error_send: 'Fehler beim Senden der Nachricht',
  messages_error_load: 'Fehler beim Laden der Nachrichten',
  messages_retry: 'Erneut versuchen',
  messages_select_player: 'Spieler auswählen, um zu chatten',
  messages_select_item: 'Item auswählen',
  messages_item_attached: 'Item angehängt',
  messages_remove_item: 'Item entfernen',
  messages_confirm: 'Bestätigen',
  messages_cancel: 'Abbrechen',
  messages_today: 'Heute',
  messages_yesterday: 'Gestern',
  messages_typing: 'tippt...',
  messages_translate: 'Übersetzen',
  messages_show_original: 'Original anzeigen',
  messages_translate_error: 'Nachricht konnte nicht übersetzt werden',
  messages_scroll_for_more: 'Nach oben scrollen für ältere Nachrichten',

  notifications_title: 'Benachrichtigungen',
  notifications_no_notifications: 'Keine Benachrichtigungen verfügbar',
  notifications_no_type: 'Kein Typ',
  notifications_published: 'Veröffentlicht:',
  notifications_expires: 'Läuft ab:',
  notifications_like: 'Gefällt mir',
  notifications_dislike: 'Gefällt mir nicht',
  notifications_back_to_notifications: 'Zurück zu Benachrichtigungen',
  notifications_vote_error: 'Fehler beim Aktualisieren der Abstimmung',
  notifications_loading: 'Laden...',
  notifications_error_load: 'Fehler beim Laden der Benachrichtigungen',
  notifications_not_found: 'Benachrichtigung nicht gefunden oder nicht verfügbar',

  dt_title: 'Tägliche Aufgaben',
  dt_global_progress: 'Globaler Fortschritt',
  dt_tasks_completed: 'Aufgaben abgeschlossen',
  dt_no_tasks: 'Derzeit sind keine Aufgaben verfügbar.',
  dt_claimed: 'Eingelöst',
  dt_incomplete: 'Unvollständig',
  dt_final_rewards: 'Finale Belohnungen',
  dt_final_rewards_description:
    'Alle täglichen Aufgaben abschließen und alle Belohnungen einlösen, um diese finalen Belohnungen freizuschalten.',
  dt_claim_final_reward: 'Finale Belohnung einlösen',
  dt_complete_all_first: 'Alle täglichen Aufgaben müssen zuerst abgeschlossen und eingelöst werden',
  dt_success: 'Erfolg',
  dt_error: 'Fehler',
  dt_network_error: 'Netzwerkfehler',
  dt_processing: 'Wird verarbeitet...',
  dt_login_required: 'Sie müssen angemeldet sein, um tägliche Aufgaben zu sehen.',
  dt_load_error: 'Tägliche Aufgaben konnten nicht geladen werden.',

  don_package: 'Paket:',
  don_silks: 'Silks:',
  don_price: 'Preis:',
  don_silks_label: 'Silks',
  don_vip_points: '{amount} VIP-Punkte',
  don_promo: 'Promo',
  don_special_offer: 'Sonderangebot',
  don_back: '← Zurück',
  don_pay: 'Zahlen $',
  don_continue_paypal: 'Weiter zu PayPal',
  don_processing: 'Verarbeitung...',
  don_binance_soon: 'Binance-Zahlung kommt bald...',
  don_error_create: 'Fehler beim Erstellen der Zahlung',
  don_stripe_not_loaded: 'Stripe SDK nicht geladen',
  don_success_processing: 'Zahlung wird verarbeitet...',
  don_success_wait: 'Bitte warten, Spende wird bestätigt.',
  don_success_ok: 'Zahlung erfolgreich!',
  don_success_fail: 'Zahlung nicht abgeschlossen',
  don_success_fail_msg: 'Spende konnte nicht bestätigt werden. Bitte erneut versuchen.',
  don_cancel_title: 'Zahlung abgebrochen',
  don_cancel_msg: 'Spende nicht abgeschlossen. Du kannst es jederzeit erneut versuchen.',
  don_back_to: 'Zurück zu Spenden',
  don_credited: '{amount} Silks wurden deinem Konto gutgeschrieben.',
  cal_claimed: 'Eingelöst',
  cal_locked: 'Gesperrt',
  cal_today: 'Heute',
  cal_claim: 'Einlösen',
  cal_streak_label: 'Tage eingecheckt',
  cal_consecutive_login: 'Konsekutives Login',
  cal_upcoming: 'Demnächst',
  cal_upcoming_rewards: 'Kommende Belohnungen',
  cal_no_upcoming: 'Keine nächsten',
  cal_monthly_bonus: 'Monatsbonus',
  cal_monthly_bonus_desc: 'Checke {days} Tage ein, um den Monatsbonus zu erhalten.',
  cal_days_remaining: '{days} Tage verbleibend',
  cal_day_remaining: '1 Tag verbleibend',
  cal_info_title: 'Event-Info',
  cal_default_desc: 'Melde dich jeden Tag an, um exklusive Belohnungen zu erhalten. Einen Tag verpasst? Mach weiter, das Imperium wartet.',
  cal_prev: 'Zurück',
  cal_next: 'Weiter',
  cal_bonus_days_unit: 'Tage',
  cal_bonus_n_day: '1 Tag',
  cal_bonus_n_days: '{days} Tage',
  cal_bonus_7_days: '7 Tage',
  cal_bonus_15_days: '15 Tage',
  cal_bonus_1_month: '1 Monat',
  bp_multiple_items: 'Mehrere Items verfügbar',
  vip_title: 'VIP-System',
  vip_col_level: 'STUFE',
  vip_col_progress: 'FORTSCHRITT',
  vip_col_rewards: 'BELOHNUNGEN',
  vip_col_state: 'STATUS',
  vip_level_label: 'VIP-Stufe ({level})',
  vip_state_unlocked: 'Unlocked',
  vip_no_levels: 'No VIP levels configured.',
  vip_points_rate: '{points} VIP Points.',
  vip_your_points: 'Your points',
  vip_current_level: 'Current level',
  vip_next_level: 'Next level',
  vip_all_unlocked: 'All levels unlocked',
  vip_points_remaining: '{points} points to go',
  vip_information: 'VIP information',
  vip_close: 'Close',
  vip_info_account: 'VIP points belong to your account. Only completed donations with credited VIP points count.',
  vip_info_unlock: 'Reach the required points to unlock each level. Your points accumulate and are not spent when a level unlocks.',
  vip_info_rewards: 'Unlocked means you meet the requirement. Reward claiming and delivery are not available yet.',
  vip_state_locked: 'Gesperrt',
  vip_note: 'Für jeden gespendeten $1 erhältst du',
  vip_note_points: '10 VIP-Punkte.',
  don_history: "Kaufverlauf",
  don_history_loading: "Käufe werden geladen...",
  don_history_error: "Der Kaufverlauf konnte nicht geladen werden.",
  don_history_empty: "Noch keine Käufe.",
  don_history_date: "Datum",
  don_history_method: "Zahlungsart",
  don_history_status: "Status",
  don_history_previous: "Zurück",
  don_history_next: "Weiter",
  don_status_completed: "Abgeschlossen",
  don_status_pending: "Ausstehend",
  don_status_cancelled: "Storniert",
  don_status_failed: "Fehlgeschlagen",
  don_daily_limit: "Du hast in den letzten 24 Stunden {current} ausgegeben. Mit diesem Kauf über {amount} wären es {total}, mehr als das Limit von {limit}. Es sind noch {remaining} verfügbar.",
  don_limit_available: "Verfügbar: {amount}",
  don_reset_ready: "Zahlungen der letzten 24 Std.",
  don_reset_updating: "Limit wird aktualisiert...",
  don_reset_error: "Limit nicht verfügbar",
  don_reset_in: "Zurücksetzung in {time}",
  don_limit_locked: "Du hast das Zahlungslimit erreicht. Warte, bis der Countdown in der Kopfzeile abgelaufen ist.",
} as const;

export default de;
